import { render, staticRenderFns } from "./DraftCreated.vue?vue&type=template&id=4173ed78&"
import script from "./DraftCreated.vue?vue&type=script&lang=js&"
export * from "./DraftCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports